// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';
import Tooltip from 'core/tools/Tooltip';

export const CUSTOMER_TYPES = {
  individual: {
    label: 'Individual',
    id: 1
  },
  organization: {
    label: 'Organization',
    id: 2
  }
}

export const SALE_TYPES_NEW = [
  {
    label: 'Retail',
    value: '1'
  },{
    label: 'DX / Wholesale',
    value: '2'
  }
];

export const SALE_TYPES_PRE = [
  {
    label: 'Retail',
    value: '1'
  },{
    label: 'Wholesale',
    value: '2'
  }
];

export const PURCHASE_TYPES = [
  {
    label: 'Purchase',
    value: '1'
  },{
    label: 'Lease',
    value: '2'
  }
];

export const SUB_TYPES_NEW = [
  {
    label: 'New Standard',
    value: '5'
  },{
    label: 'New Demo',
    value: '6'
  },{
    label: 'New Loaner',
    value: '7'
  }
];

export const WHOLESALE_FORMAT = [
  {
    label: 'Simplified',
    value: '1',
    append: (
      <Tooltip
        variant="danger"
        tip="If you choose Simplified view, you will not be able to convert this deal into Detailed view."
      >
        <Sprite use="info" fill="danger" className="mt-n1" />
      </Tooltip>
    )
  },{
    label: 'Detailed',
    value: '2'
  }
];

export const IS_FINANCED_OPTIONS = [
  {
    value: 'true',
    label: 'Bank'
  },{
    value: 'false',
    label: 'Customer (Cash)'
  }
];
export const DSL_CUSTOMER_SOURCE_ID = [
  {
    value: '1',
    label: 'Personal Check'
  },{
    value: '2',
    label: 'Customer Bank'
  },{
    value: '3',
    label: 'Other'
  }
];


// LOOKUP PARAMS / OPTION KEYS
export const LOOKUP_PARAMS = {
  salesStaff: {
    charKey: 'SLSSTF'
  },
  salesManager: {
    charKey: 'SLSMGR'
  },
  finance: {
    charKey: 'FINACE'
  }
};
export const FINANCESTAFF_KEYS = {
  label: 'name',
  value: 'site_user_id'
};
export const CUSTOMER_KEYS = {
  label: 'customer_source_name',
  value: 'dsl_customer_source_id'
};
export const LENDER_KEYS = {
  label: 'lender_name',
  value: 'dsl_lender_id'
};
export const EMPLOYEE_OPTION_KEYS = {
  label: 'name',
  value: 'site_user_id'
};
export const STATES_KEYS = {
  label: 'state_name',
  value: 'state_code'
};
export const WARRANTY_OPTION_KEYS = {
  label: 'warranty_type_name',
  value: 'warranty_type_id'
};
export const VEHICLE_MAKE_OPTION_KEYS = {
  label: 'vehicle_make_name',
  value: 'vehicle_make_id'
}
export const INVENTORY_SOURCE_OPTION_KEYS = {
  label: 'inventory_source',
  value: 'inventory_source_id'
};
export const INVENTORY_LOCATIONS_OPTION_KEYS = {
  label: 'inventorylocation_type_name',
  value: 'inventorylocation_type_id'
};
export const YES_NO_NUMERIC = {
  0: 'No',
  1: 'Yes'
};
